import { TYPE_BEAT_ENUM } from '@/shared/config';
import { TBeatHrActiveTab } from './reportTypes';

export interface IListSelectedCells {
  id: string;
  index: number;
  value: number;
}

export interface IHolterRrCell {
  id: string;
  row: number;
  col: number;
  count?: number;
  type?: number;
  isReviewed?: boolean;
}

export type TKeyHeatmap = keyof Pick<typeof TBeatHrActiveTab, 'N' | 'S' | 'V' | 'qToQ' | 'qToNSV'>;

export type DataHeatmapChart<Type> = {
  [K in TKeyHeatmap]: Type;
};

export type TDataHeatmapChart = DataHeatmapChart<IHolterRrCell[]>;
export const DATA_HEATMAP_STATUS = {
  INITIAL: 'INITIAL',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  EMPTY: 'EMPTY',
} as const;

export type TDataHeatmapStatus = (typeof DATA_HEATMAP_STATUS)[keyof typeof DATA_HEATMAP_STATUS];

export const LOAD_BEAT_STATUS = {
  FETCH: 'FETCH',
  RELOAD: 'RELOAD',
  NONE: 'NONE',
} as const;

export interface ILoadBeatStatus {
  status: (typeof LOAD_BEAT_STATUS)[keyof typeof LOAD_BEAT_STATUS];
}

export const JUMP_DATE_STATUS = {
  NORMAL: 'NORMAL',
  MINHR: 'MINHR',
  MAXHR: 'MAXHR',
} as const;

export type TJumpDateStatus = (typeof JUMP_DATE_STATUS)[keyof typeof JUMP_DATE_STATUS];

export type TRrOverview = {
  reviewed: Number;
  total: Number;
  isEmpty?: Boolean;
};

export const BULK_ACTION_ENUM = {
  NOTHING: 'NOTHING',
  ALL_N: TYPE_BEAT_ENUM.N,
  ALL_S: TYPE_BEAT_ENUM.S,
  ALL_V: TYPE_BEAT_ENUM.V,
  ALL_Q: TYPE_BEAT_ENUM.Q,
  ALL_DELETE: TYPE_BEAT_ENUM.DELETED,
  SWAP_TEMPLATE: 'SWAP_TEMPLATE',
  MARK_REVIEWED: 'MARK_REVIEWED',
} as const;

export type TBulkAction = (typeof BULK_ACTION_ENUM)[keyof typeof BULK_ACTION_ENUM];
